import React, { useState } from 'react';
import { ReadMoreContainer, ReadMoreShowLess, TextContainer } from './style';

type ReadMoreTextProps = {
  text: string;
};

const ReadMoreText = ({ text }: ReadMoreTextProps) => {
  const [readMore, setReadMore] = useState(text?.length > 70);
  if (!text) return <></>;
  const handleReadMore = () => {
    setReadMore((readMoreToUpdate) => !readMoreToUpdate);
  };
  return (
    <ReadMoreContainer>
      <TextContainer more={readMore}>
        {text}
      </TextContainer>
      {text.length > 70
      && <ReadMoreShowLess more={readMore} onClick={handleReadMore}>
        {readMore ? 'Read More...' : 'Show Less'}
      </ReadMoreShowLess>
      }
    </ReadMoreContainer>
  );
};

export default ReadMoreText;
